/**
 * Application footer. States the privacy posture plainly, because "your keys
 * stay in your browser" is the main thing a new user needs to trust.
 *
 * @returns The rendered footer.
 */
export function SiteFooter(): React.JSX.Element {
  return (
    <footer className="border-t border-border py-6">
      <div className="mx-auto w-full max-w-6xl px-4 text-sm text-muted-foreground">
        <p>
          Runs entirely in your browser. Your API keys and search history are
          stored on this device and are never sent to any server but
          Google&apos;s.
        </p>
      </div>
    </footer>
  );
}
